import { api } from "../lib/axios";

const ACCESS_TOKEN_KEY = "access_token";
const REFRESH_TOKEN_KEY = "refresh_token";

function clearTokens() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
}

export async function handleLogout() {
  const accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);
  const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);

  try {
    if (accessToken) {
      await api.post(
        '/auth/glogout/',
        {refresh_token : refreshToken},
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
    }
  } catch (err) {
    console.warn("Logout request failed:", err);
  } finally {
    clearTokens();
    window.location.href = "/login";
  }
}
